import { render, staticRenderFns } from "./BrandHeader.vue?vue&type=template&id=e02d9960&scoped=true"
import script from "./BrandHeader.vue?vue&type=script&lang=js"
export * from "./BrandHeader.vue?vue&type=script&lang=js"
import style0 from "./BrandHeader.vue?vue&type=style&index=0&id=e02d9960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02d9960",
  null
  
)

export default component.exports